import BaseService from 'services/base'

export default class GoodsReceivedService extends BaseService {
  constructor(api) {
    const url = 'goodsreceived'
    super(api, url)
    this.api = api
    this.url = url
  }
}
